document.addEventListener("DOMContentLoaded", function(event) {
    function createCookie(cookieName,cookieValue,daysToExpire)
    {
        var date = new Date();
        date.setTime(date.getTime()+(daysToExpire*24*60*60*1000));
        document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString() + "; path=/";
    }
    function accessCookie(cookieName)
        {
          var name = cookieName + "=";
          var allCookieArray = document.cookie.split(';');
          for(var i=0; i<allCookieArray.length; i++)
          {
            var temp = allCookieArray[i].trim();
            if (temp.indexOf(name)==0)
            return temp.substring(name.length,temp.length);
       	  }
        	return "";
    }
    if (!document.getElementById('age-verification')) return;
    if(!accessCookie('ages')){document.getElementById('age-verification').style.display = "flex";}
    let _legalHolder = document.getElementById("input-group");
    let _buttonRadioLegal = _legalHolder.querySelectorAll('input[name=legal]');
    let _enterWithoutEmail = document.getElementById("enter");
    _enterWithoutEmail.addEventListener('click', (e)=>{
        e.preventDefault();
        $('.age-verification').fadeOut();
    });
    for(let e = 0 ; e < _buttonRadioLegal.length ; e++) {
        _buttonRadioLegal[e].addEventListener('click', ()=>{
            let _buttonRadioLegalValue = _buttonRadioLegal[e].value;   
            console.log(_buttonRadioLegalValue);
            if (_buttonRadioLegalValue == 'yes') {
                $('.email-form').slideDown();
                $('.age-verification_ChoiceNo').slideUp();
                createCookie('ages',"verified",365)
            }
            if (_buttonRadioLegalValue == 'no') {
                $('.email-form').slideUp();
                $('.age-verification_ChoiceNo').slideDown();
                window.open(' https://www.responsibility.org');
            }
        });
    }
});

window.addEventListener("klaviyoForms", function(e) {
    if (e.detail.type == 'submit') {
      console.log('klaviyo submit');
      $('.age-verification').fadeOut();
    }
  });

document.addEventListener("DOMContentLoaded", function() {
  function initClubCarousels() {
    document.querySelectorAll('[data-club-carousel]').forEach(function(root) {
      var viewport = root.querySelector('.club-carousel__viewport');
      var slides = Array.prototype.slice.call(root.querySelectorAll('.club-carousel__slide'));
      var allDots = Array.prototype.slice.call(root.querySelectorAll('.club-carousel__dot'));
      var prevBtn = root.querySelector('.club-carousel__arrow--prev');
      var nextBtn = root.querySelector('.club-carousel__arrow--next');

      if (!viewport || !slides.length) {
        return;
      }

      // A slide near the end of the track often can't be scrolled flush-left
      // without overshooting the max scroll position, so several trailing
      // slide indices collapse to the same (clamped) scroll position. Build
      // the actual set of distinct, reachable stops instead of assuming one
      // stop per slide, so dots map 1:1 with what's really reachable.
      var stops = [];
      var dots = [];

      function buildStops() {
        var maxScrollLeft = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        var uniqueStops = [];
        slides.forEach(function(slide) {
          var target = Math.min(slide.offsetLeft - viewport.offsetLeft, maxScrollLeft);
          if (!uniqueStops.length || target > uniqueStops[uniqueStops.length - 1] + 1) {
            uniqueStops.push(target);
          }
        });
        if (!uniqueStops.length) {
          uniqueStops.push(0);
        }
        stops = uniqueStops;

        allDots.forEach(function(dot, index) {
          dot.style.display = index < stops.length ? '' : 'none';
        });
        dots = allDots.slice(0, stops.length);
      }

      function closestStopIndex() {
        var scrollLeft = viewport.scrollLeft;
        var closest = 0;
        var closestDistance = Infinity;
        stops.forEach(function(stop, index) {
          var distance = Math.abs(stop - scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closest = index;
          }
        });
        return closest;
      }

      function setActiveDot(index) {
        dots.forEach(function(dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === index);
        });
      }

      function scrollToStop(index) {
        index = Math.max(0, Math.min(index, stops.length - 1));
        viewport.scrollTo({
          left: stops[index],
          behavior: 'smooth'
        });
      }

      buildStops();

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          scrollToStop(closestStopIndex() - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          scrollToStop(closestStopIndex() + 1);
        });
      }

      allDots.forEach(function(dot, index) {
        dot.addEventListener('click', function() {
          if (index < stops.length) {
            scrollToStop(index);
          }
        });
      });

      if (allDots.length) {
        var scrollTimer;
        viewport.addEventListener('scroll', function() {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(function() {
            setActiveDot(closestStopIndex());
          }, 100);
        });
        setActiveDot(0);
      }

      var resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          buildStops();
          setActiveDot(closestStopIndex());
        }, 150);
      });
    });
  }

  function initLandingWhiskeyCarousels() {
    document.querySelectorAll('.landing-whiskey-carousel__viewport').forEach(function(viewport) {
      var slides = Array.prototype.slice.call(viewport.querySelectorAll('.landing-whiskey-carousel__slide'));
      if (!slides.length) return;

      var root = viewport.closest('.landing-whiskey-carousel');
      var dots = root ? Array.prototype.slice.call(root.querySelectorAll('.landing-whiskey-carousel__dot')) : [];
      var prevArrow = root ? root.querySelector('.landing-whiskey-carousel__arrow--prev') : null;
      var nextArrow = root ? root.querySelector('.landing-whiskey-carousel__arrow--next') : null;
      var activeIndex = 0;
      var track = viewport.querySelector('.landing-whiskey-carousel__track');

      // Chrome doesn't count a flex scroll container's own padding-right
      // toward its scrollable overflow, so trailing padding is visually
      // present but unreachable: the last slide(s) can never scroll to
      // center and collapse onto the max-scroll position. A real flex
      // child at the end *is* counted, so it supplies that trailing room.
      var tailSpacer = null;
      if (track) {
        tailSpacer = document.createElement('div');
        tailSpacer.className = 'landing-whiskey-carousel__spacer';
        tailSpacer.setAttribute('aria-hidden', 'true');
        track.appendChild(tailSpacer);
      }

      // The track's CSS padding isn't wide enough to let the first/last
      // slide ever reach the viewport's center, so they can never become
      // "active" and their dots can look unresponsive. The left edge can
      // use padding (resting at scrollLeft 0 is always valid); the right
      // edge must come from the spacer for the reason noted above.
      function updateEdgePadding() {
        if (!track) return;
        var viewportWidth = viewport.clientWidth;
        var firstWidth = slides[0].getBoundingClientRect().width;
        var lastWidth = slides[slides.length - 1].getBoundingClientRect().width;
        track.style.paddingLeft = Math.max(0, (viewportWidth - firstWidth) / 2) + 'px';
        track.style.paddingRight = '0px';
        if (tailSpacer) {
          // Subtract one gap: flex `gap` also inserts space between the
          // last slide and the spacer, which would otherwise over-shift
          // the reachable center by that much.
          var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          tailSpacer.style.flex = '0 0 ' + Math.max(0, (viewportWidth - lastWidth) / 2 - gap) + 'px';
        }
      }

      function updateArrows() {
        if (prevArrow) prevArrow.disabled = activeIndex <= 0;
        if (nextArrow) nextArrow.disabled = activeIndex >= slides.length - 1;
      }

      function updateActiveSlide() {
        var maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;
        var scrollLeft = viewport.scrollLeft;
        var closestIndex;

        // Even with edge padding, subpixel rounding can leave the last
        // slide's center a hair off from the viewport's center, so a
        // pure distance comparison can keep favoring its neighbor once
        // scroll is maxed out. Treat the actual scroll boundaries as
        // unambiguous signals instead of leaving it to the tie-break.
        // The tolerance has to be more than 1px: scrollWidth/clientWidth
        // are rounded to whole pixels while scrollLeft stays fractional,
        // and at non-100% browser/OS zoom that rounding gap can exceed
        // 1px, so the browser's true max scroll never satisfies a 1px
        // check even though the user is fully scrolled to the end.
        var EDGE_TOLERANCE = 2;
        if (scrollLeft <= EDGE_TOLERANCE) {
          closestIndex = 0;
        } else if (scrollLeft >= maxScrollLeft - EDGE_TOLERANCE) {
          closestIndex = slides.length - 1;
        } else {
          var viewportRect = viewport.getBoundingClientRect();
          var viewportCenter = viewportRect.left + viewportRect.width / 2;
          var closestDistance = Infinity;
          closestIndex = 0;
          slides.forEach(function(slide, index) {
            var rect = slide.getBoundingClientRect();
            var slideCenter = rect.left + rect.width / 2;
            var distance = Math.abs(slideCenter - viewportCenter);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });
        }

        activeIndex = closestIndex;
        slides.forEach(function(slide, index) {
          slide.classList.toggle('is-active', index === closestIndex);
        });
        dots.forEach(function(dot, index) {
          dot.classList.toggle('is-active', index === closestIndex);
        });
        updateArrows();
      }

      function scrollToIndex(index) {
        var slide = slides[Math.max(0, Math.min(index, slides.length - 1))];
        if (!slide) return;

        // Let the browser own the scroll + snap together instead of
        // computing a pixel target and toggling scroll-snap-type off
        // around it: that toggle raced the smooth-scroll animation, and
        // restoring snap before the animation actually finished let the
        // browser "correct" the still-moving scroll onto the last slide's
        // snap point instead of this one's.
        slide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }

      dots.forEach(function(dot, index) {
        dot.addEventListener('click', function() {
          scrollToIndex(index);
        });
      });

      if (prevArrow) {
        prevArrow.addEventListener('click', function() {
          scrollToIndex(activeIndex - 1);
        });
      }

      if (nextArrow) {
        nextArrow.addEventListener('click', function() {
          scrollToIndex(activeIndex + 1);
        });
      }

      var scrollTimer;
      viewport.addEventListener('scroll', function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(updateActiveSlide, 50);
      });

      var resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          updateEdgePadding();
          updateActiveSlide();
        }, 150);
      });

      updateEdgePadding();

      var initialSlide = slides[Math.floor((slides.length - 1) / 2)];
      if (initialSlide) {
        // Set scrollLeft directly rather than initialSlide.scrollIntoView():
        // scrollIntoView walks the whole ancestor chain, so on a carousel
        // that loads below the fold it would yank the page down to reveal
        // it. This only touches the viewport's own horizontal scroll.
        var viewportRect = viewport.getBoundingClientRect();
        var slideRect = initialSlide.getBoundingClientRect();
        var delta = (slideRect.left + slideRect.width / 2) - (viewportRect.left + viewportRect.width / 2);
        viewport.scrollLeft += delta;
      }

      updateActiveSlide();
    });
  }

  function initClubCompareModal() {
    document.querySelectorAll('[data-club-compare-backdrop]').forEach(function(backdrop) {
      var panel = backdrop.querySelector('[data-club-compare-modal]');
      var root = backdrop.parentElement;
      var openTriggers = root ? root.querySelectorAll('[data-club-compare-open]') : [];
      var closeTriggers = backdrop.querySelectorAll('[data-club-compare-close]');

      if (!panel || !openTriggers.length) {
        return;
      }

      function openModal() {
        backdrop.hidden = false;
        requestAnimationFrame(function() {
          backdrop.classList.add('is-visible');
        });
        document.documentElement.classList.add('club-compare-modal-open');
        panel.focus();
      }

      function closeModal() {
        backdrop.classList.remove('is-visible');
        document.documentElement.classList.remove('club-compare-modal-open');
        function onTransitionEnd(e) {
          if (e.target !== backdrop) return;
          backdrop.hidden = true;
          backdrop.removeEventListener('transitionend', onTransitionEnd);
        }
        backdrop.addEventListener('transitionend', onTransitionEnd);
      }

      openTriggers.forEach(function(trigger) {
        trigger.addEventListener('click', openModal);
      });

      closeTriggers.forEach(function(trigger) {
        trigger.addEventListener('click', closeModal);
      });

      backdrop.addEventListener('click', function(e) {
        if (e.target === backdrop) closeModal();
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && !backdrop.hidden) closeModal();
      });
    });
  }

  initClubCarousels();
  initLandingWhiskeyCarousels();
  initClubCompareModal();
});